var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page)?_c('div',[_c('div',{staticClass:"container pb-5"},[_c('div',{staticClass:"pt-5 pb-5 d-flex"},[_c('h1',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.page.title))])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.page.content)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }